// src/context/LoaderController.js

let activeRequests = 0;
let registeredSetter = null;

/**
 * Register the React setter so the controller can update global loading state.
 * Passing `null` will unregister.
 */
export const registerGlobalLoader = (setterFn) => {
  registeredSetter = setterFn;

  // Immediately sync state on registration
  if (registeredSetter) {
    try {
      registeredSetter(activeRequests > 0);
    } catch (err) {
      console.error("LoaderController: error calling registered setter:", err);
    }
  }
};

/**
 * Safely dispatch DOM event (old system support)
 */
const dispatchLoadingEvent = (isLoading) => {
  try {
    const ev = new CustomEvent("global-loading", { detail: isLoading });
    window.dispatchEvent(ev);
  } catch (err) {
    console.error("LoaderController: failed to dispatch global-loading event:", err);
  }
};

/**
 * Update global loading (increment/decrement)
 */
export const setGlobalLoading = (isLoading) => {
  if (isLoading) {
    activeRequests += 1;
  } else {
    activeRequests = Math.max(0, activeRequests - 1);
  }

  const currentState = activeRequests > 0;

  // Update React context
  if (registeredSetter) {
    try {
      registeredSetter(currentState);
    } catch (err) {
      console.error("LoaderController: error updating React loader state:", err);
    }
  }

  // Emit event for older pages
  dispatchLoadingEvent(currentState);
};

/**
 * Force reset loader system
 */
export const resetGlobalLoader = () => {
  activeRequests = 0;

  if (registeredSetter) {
    try {
      registeredSetter(false);
    } catch (err) {
      console.error("LoaderController: error resetting React loader state:", err);
    }
  }

  dispatchLoadingEvent(false);
};
